import { Controller } from "stimulus"
import Utility from 'classes/Utility';
import Events from 'classes/Events';
import RequestQueue from 'classes/RequestQueue';

class WatchlistActionController extends Controller {
  static values = {
    state: Boolean,
    symbol: String,
    type: String,
    securityType: String
  }

  static classes = [
    'buttonSelectedBg',
    'buttonUnselectedBg',
  ]

  initialize() {
    this.initializing = true;
  }

  async connect() {
    this.__updateDslName();
    try {
      const response = await Utility.getConfigData({
        type: 'current_user'
      });
      const { premium } = response.data;
      this.isPremium = premium;
    } catch (e) {
      this.isPremium = false;
    }
    this.initializing = false;
  }

  toggleState = e => {
    e.preventDefault();
    if (this.isPremium) {
      this.stateValue = !this.stateValue;
    } else {
      this.element.dispatchEvent(Events.errorEvent);
    }
  }

  stateValueChanged() {
    this.__updateDslName();
    this.__updateComponentRenderData();
    this.__renderContentWithContext({
      activeClass: this.buttonSelectedBgClass,
      inactiveClass: this.buttonUnselectedBgClass,
      state: this.stateValue
    });
    if (!this.initializing) {
      this.element.dispatchEvent(Events.successEvent);
      if (this.stateValue) {
        RequestQueue.addToQueue({
          url: `/api/dividend/watch_list/${this.symbolValue}/`,
          method: 'put',
          data: {
            security_type: this.securityTypeValue
          }
        }).then(this.__handleSuccessfulAdd)
      } else {
        RequestQueue.addToQueue({
          url: `/api/dividend/watch_list/${this.symbolValue}/`,
          method: 'delete',
          data: {
            security_type: this.securityTypeValue
          }
        }).then(this.__handleSuccessfulRemove)
      }
    }
  }

  __handleSuccessfulAdd = response => {
    const { data } = response;
    const { security_id } = data;
    EventManager.emit('watchlist-updated', {
      securityId: security_id,
      action: 'add'
    })

    window.EventManager.emit('flash-message', {
      status: 'INFO',
      title: 'Added to your Watchlist',
      dslName: 'ConfirmationMessageAddToWatchlist'
    })
  }

  __handleSuccessfulRemove = response => {
      const { data } = response;
      const { security_id } = data;
      EventManager.emit('watchlist-updated', {
        securityId: security_id,
        action: 'remove'
      })
      window.EventManager.emit('flash-message', {
        status: 'INFO',
        title: 'Removed from your Watchlist',
        dslName: 'ConfirmationMessageRemovedFromWatchlist'
      })
  }

  __renderContentWithContext = ({ activeClass, inactiveClass, state }) => {
    if (state) {
      this.element.classList.add(activeClass)
      this.element.classList.remove(inactiveClass)
    } else {
      this.element.classList.add(inactiveClass)
      this.element.classList.remove(activeClass)
    }
  }

  __updateDslName = () => {
    if (this.stateValue) {
      this.element.setAttribute('data-dsl-name', 'FormFieldWatchlistRemoveSubmit')
    } else {
      this.element.setAttribute('data-dsl-name', 'FormFieldWatchlistAddSubmit')
    }
  }

  __updateComponentRenderData = () => {
    let currentUrlData = JSON.parse(this.element.dataset['componentRenderUrlData'] || '');
    currentUrlData['state'] = `${this.stateValue}`;
    currentUrlData['type'] = this.typeValue;
    currentUrlData['device_type'] = Utility.getDeviceType();
    this.element.dataset['componentRenderUrlData'] = JSON.stringify(currentUrlData);
  }
}

export default WatchlistActionController;
